const BASE_URL = 'https://ezcar-backend.onrender.com';
// const BASE_URL = 'http://localhost:3000';
const IMAGE_URL = 'https://ik.imagekit.io/ezcar';
const LOG_IN = '/login';
const LOG_OUT = '/logout';
const SIGN_UP = '/signup';
const CARS = '/api/v1/cars';
const RESERVATION = '/api/v1/reservations';
const IMAGE_AUTH = '/private/auth_params';
const IMAGE_KEY = 'public_eInAT404MVNpMKyc+zehqaVtmN0=';

export {
  BASE_URL, LOG_IN, LOG_OUT, SIGN_UP, CARS, RESERVATION, IMAGE_URL, IMAGE_AUTH, IMAGE_KEY,
};
